export default "<span class=\"failed\">\r\n    Your message is not deliverd. Please contact us here : {{ this.adminEmail }}\r\n</span>"